import { Clause } from "@radarly/models/clause";
import { cleanApiClause } from "@radarly/models/clause/api";
import { Historicals } from "@radarly/models/historical";
import { Post } from "@radarly/models/posts";
import {
  SearchData,
  SearchParams,
  WarmupSearchParams,
} from "@radarly/models/search";
import { RadarlyAPI } from "./base";

export interface SearchWarmupParams {
  from: string;
  to: string;
  clause: Clause;
  pagination?: {
    limit?: number;
    sortBy?: "date";
    sortOrder?: "asc" | "desc";
  };
}

export interface SearchVolumeEstimation {
  estimated: number;
}

export class WarmupAPI extends RadarlyAPI {
  public async searchWarmups({ pagination, ...params }: SearchWarmupParams) {
    return await this.post<{
      hits: Post[];
      took: number;
      total: number;
    }>("/warmup/search.json", {
      ...params,
      pagination: {
        limit: pagination?.limit || 250,
        sortBy: pagination?.sortBy || "date",
        sortOrder: pagination?.sortOrder || "desc",
      },
    });
  }
  public async getWarmupCount() {
    return await this.get("/warmup/count.json");
  }
  public async getWarmupLastMonthCount() {
    return await this.get("/warmup/count/lastmonth.json");
  }
  public async searchWarmupPosts<T extends SearchData>(
    project: number,
    query: SearchParams
  ) {
    const validQuery: WarmupSearchParams = {
      ...query,
      hasHighLighting: query.highlight,
      clause: cleanApiClause(query.query),
    };
    return await this.post<T>(`/warmup/${project}/search.json`, validQuery);
  }
  public async retrieveData(projectId: number, params: SearchWarmupParams) {
    return await this.post<{
      expected: number;
      warmupId: number;
    }>(`/warmup/request/${projectId}`, params);
  }
  public async getHistoricals(projectId: number) {
    const page = 0;
    const states = "initializing,processing";
    const nb = 25;
    const order = "id desc";

    return await this.get<Historicals>(
      `/warmups/${projectId}.json?nb=${nb}&page=${page}&order=${order}&states=${states}`
    );
  }
  public async getHistoricalEstimation(
    projectId: number,
    params: SearchWarmupParams
  ) {
    return await this.post<SearchVolumeEstimation>(
      `/warmup/request-estimate/${projectId}.json`,
      params
    );
  }
}
